import { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../API';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await requestPasswordReset({ email });
      setSuccess(response.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container pt-4">
      <div className="container-fluid col-sm-8 col-lg-6">
        <div className="jumbotron mt-2">
          <h1 className="display-4">Mot de passe oublié</h1>

          {success ? (
            <>
              <div className="alert alert-success" role="alert">
                {success}
              </div>
              <p className="mb-0">
                Consultez votre boîte de réception et suivez le lien pour choisir un nouveau mot de passe.
              </p>
            </>
          ) : (
            <>
              <p className="lead">
                Entrez votre courriel et nous vous enverrons un lien pour réinitialiser votre mot de passe.
              </p>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Courriel</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-primary btn-block auth-actions-btn" disabled={loading}>
                  {loading ? 'Envoi...' : 'Envoyer le lien'}
                </button>
              </form>
            </>
          )}

          <div className="auth-footer-links">
            <p>
              <Link to="/login">Retour à la connexion</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
